import { faEyeSlash } from '@fortawesome/pro-light-svg-icons/faEyeSlash';
import React, { CSSProperties, FunctionComponent, MouseEventHandler, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Container } from './PropertyFavourite.style';
import { HideBox, HideBtnText } from './PropertyHide.style';

/* istanbul ignore next */
const DELAY = process?.env?.JEST_WORKER_ID ? 0 : 1000;

interface Props {
  containerStyle?: CSSProperties;
  hidden: boolean;
  onHideToggle: (hidden: boolean) => Promise<boolean>;
  innerRef?: React.RefObject<HTMLButtonElement>;
  button?: boolean;
  showLabel?: boolean;
  color?: string;
}

const PropertyHide: FunctionComponent<Props> = (props) => {
  const theme = useTheme();
  const [playState, setPlayState] = useState<'running' | 'paused'>('paused');
  const [hidden, setHidden] = useState<boolean>(props.hidden);

  const handleClick: MouseEventHandler = async (e) => {
    e.preventDefault();

    setHidden(!hidden);
    setPlayState('running');

    setTimeout(() => {
      setPlayState('paused');
    }, DELAY);

    const loggedIn = await props.onHideToggle(!hidden);

    if (!loggedIn) {
      setHidden(false);
    }
  };

  useEffect(() => {
    if (props.hidden !== hidden) {
      setHidden(props.hidden);
    }
  }, [props.hidden]);

  return (
    <Container
      ref={props.innerRef}
      style={props.containerStyle}
      onClick={handleClick}
      tabIndex={-1}
      className="hide-print"
      data-testid="property-hidden-button"
      type="button"
      aria-label="Hide property"
      $color={props.color}
    >
      <HideBox playState={playState} $button={!!props.button}>
        <FontAwesomeIcon
          icon={faEyeSlash}
          size={props.button ? 18 : 22}
          color={hidden ? theme.primary : props.color}
          style={{ marginTop: !props.button ? 8 : undefined }}
          testID="hidden-icon"
        />
      </HideBox>

      {props.button && <HideBtnText>Unhide</HideBtnText>}
      {props.showLabel && <span>Hide</span>}
    </Container>
  );
};

export default PropertyHide;
